import styled from 'styled-components';
import { rem, colors, device } from '../lib/global-styles';

export const Title = styled.h2`
  display: flex;
  color: ${colors.black};
  font-size: ${props => (props.small ? rem(16) : rem(20))};
  letter-spacing: ${rem(0.25)};
  margin-bottom: ${rem(16)};
`;

export const Subtitle = styled.p`
  color: ${colors.darkGrey};
  font-size: ${rem(20)} !important;
  letter-spacing: ${rem(0.2)};
  line-height: ${rem(20)};
  margin-bottom: ${rem(16)};
  margin-top: ${rem(16)};

  @media ${device.mobile} {
    font-size: ${rem(16)};
  }
`;
